"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromMBToBT = exports.humanReadableFileSize = exports.TemperatureRange = exports.TemperatureUnit = exports.ValueRange = exports.Weight = exports.WeightUnit = exports.MonetaryValue = exports.ValueUnit = void 0;
const objects_1 = require("../objects");
const numbers_1 = require("../numbers");
class ValueUnit {
    constructor(unit, value) {
        this.unit = unit;
        this.value = value;
    }
}
exports.ValueUnit = ValueUnit;
class MonetaryValue {
    constructor(currency = "USD", value) {
        this.currency = currency;
        this.value = value;
    }
    static fromObj(data) {
        const value = Number(data.value);
        const { currency } = data;
        return new MonetaryValue(currency, value);
    }
    inUnit(convertToCurrency = "USD") {
        if (this.currency === convertToCurrency) {
            return this.value;
        }
        throw Error("Unsupported currency conversion");
    }
}
exports.MonetaryValue = MonetaryValue;
var WeightUnit;
(function (WeightUnit) {
    WeightUnit["LBS"] = "lbs";
    WeightUnit["KGS"] = "kgs";
})(WeightUnit = exports.WeightUnit || (exports.WeightUnit = {}));
class Weight extends ValueUnit {
    static getWeightUnit(value = "lbs") {
        return objects_1.getEnumKeyOrUndefined("weightType", WeightUnit, value.toLowerCase());
    }
    static fromObj(data) {
        var _a;
        const value = Number(data.value);
        const unit = objects_1.getEnumKey("weightType", WeightUnit, (_a = data.unit) === null || _a === void 0 ? void 0 : _a.toLowerCase());
        return new Weight(unit, value);
    }
    inUnit(convertToUnit = WeightUnit.LBS) {
        if (this.unit === WeightUnit.KGS && convertToUnit === WeightUnit.LBS) {
            return numbers_1.roundToDecimals(this.value / Weight.kgsInlbs);
        }
        if (this.unit === WeightUnit.LBS && convertToUnit === WeightUnit.KGS) {
            return numbers_1.roundToDecimals(this.value * Weight.kgsInlbs);
        }
        return this.value;
    }
    get inKgs() {
        return this.inUnit(WeightUnit.KGS);
    }
    get inLbs() {
        return this.inUnit(WeightUnit.LBS);
    }
    validate() {
        if (!this.unit) {
            throw Error("Weight unit not set");
        }
        if (this.value <= 0) {
            throw Error("Weight value must be positive");
        }
    }
}
exports.Weight = Weight;
Weight.kgsInlbs = 0.45359237;
class ValueRange {
    constructor(unit, minimum, maximum) {
        this.unit = unit;
        this.minimum = minimum;
        this.maximum = maximum;
    }
}
exports.ValueRange = ValueRange;
var TemperatureUnit;
(function (TemperatureUnit) {
    TemperatureUnit["CELSIUS"] = "C";
    TemperatureUnit["FAHRENHEIT"] = "F";
})(TemperatureUnit = exports.TemperatureUnit || (exports.TemperatureUnit = {}));
class TemperatureRange extends ValueRange {
    static fromObj(data) {
        if (data === null || data === void 0 ? void 0 : data.unit) {
            const unit = objects_1.getEnumKey("temperatureUnit", TemperatureUnit, data === null || data === void 0 ? void 0 : data.unit);
            return new TemperatureRange(unit, data === null || data === void 0 ? void 0 : data.minimum, data === null || data === void 0 ? void 0 : data.maximum);
        }
        return undefined;
    }
    validate() {
        if (!this.minimum && !this.maximum) {
            throw Error("Minimum or maximum should be set");
        }
    }
}
exports.TemperatureRange = TemperatureRange;
const humanReadableFileSize = (numBytes = 0, binary = false) => {
    let bytes = numBytes;
    const base = binary ? 1024 : 1000;
    if (bytes < base) {
        return `${bytes} B`;
    }
    const prefix = binary ? ["Ki", "Mi", "Gi"] : ["k", "M", "G"];
    let unit = -1;
    while (Math.abs(bytes) >= base && unit < prefix.length - 1) {
        bytes /= base;
        unit += 1;
    }
    return `${bytes.toFixed(1)} ${prefix[unit]}B`;
};
exports.humanReadableFileSize = humanReadableFileSize;
function fromMBToBT(value) {
    const num = typeof value === "number" ? value : Number(value);
    return num * 1048576;
}
exports.fromMBToBT = fromMBToBT;
//# sourceMappingURL=index.js.map